import React from 'react';
import { Database, MessageSquare, Plus } from 'lucide-react';

/**
 * Компонент секции дополнительных параметров
 */
const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  dataPreparationTypes,
  consultingTypes
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Plus className="w-5 h-5 mr-2 text-purple-500" />
        Дополнительные услуги
      </h3>
      
      <div className="grid grid-cols-1 gap-4">
        {/* Подготовка данных */}
        <div>
          <div className="flex items-start mb-3">
            <div className="flex items-center h-5">
              <input
                id="includeDataPreparation"
                name="includeDataPreparation"
                type="checkbox"
                checked={formData.includeDataPreparation}
                onChange={handleInputChange}
                className="form-checkbox"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="includeDataPreparation" className="font-medium text-gray-700 dark:text-gray-300 flex items-center">
                <Database className="w-4 h-4 mr-1 text-purple-500" />
                Подготовка и структурирование данных
              </label>
              <p className="text-gray-500 dark:text-gray-400 text-xs mt-0.5">
                Сбор, очистка и организация образовательных данных для ИИ-систем
              </p>
            </div>
          </div>
          
          {formData.includeDataPreparation && (
            <div className="ml-7 mb-3">
              <label htmlFor="dataPreparationType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Уровень подготовки данных
              </label>
              <select
                id="dataPreparationType"
                name="dataPreparationType"
                value={formData.dataPreparationType}
                onChange={handleInputChange}
                className={`form-select w-full ${errors.dataPreparationType ? 'input-error' : ''}`}
              >
                {dataPreparationTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </select>
              {errors.dataPreparationType && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.dataPreparationType}
                </p>
              )}
            </div>
          )}
        </div>
        
        {/* Консультационные услуги */}
        <div>
          <div className="flex items-start mb-3">
            <div className="flex items-center h-5">
              <input
                id="includeConsulting"
                name="includeConsulting"
                type="checkbox"
                checked={formData.includeConsulting}
                onChange={handleInputChange}
                className="form-checkbox"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="includeConsulting" className="font-medium text-gray-700 dark:text-gray-300 flex items-center">
                <MessageSquare className="w-4 h-4 mr-1 text-purple-500" />
                Стратегическое консультирование
              </label>
              <p className="text-gray-500 dark:text-gray-400 text-xs mt-0.5">
                Экспертная поддержка по стратегии внедрения ИИ в образовательные процессы
              </p>
            </div>
          </div>
          
          {formData.includeConsulting && (
            <div className="ml-7">
              <label htmlFor="consultingType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Уровень консультирования
              </label>
              <select
                id="consultingType"
                name="consultingType"
                value={formData.consultingType}
                onChange={handleInputChange}
                className={`form-select w-full ${errors.consultingType ? 'input-error' : ''}`}
              >
                {consultingTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </select>
              {errors.consultingType && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.consultingType}
                </p>
              )}
            </div>
          )}
        </div>
        
        {/* Информационный блок о дополнительных услугах */}
        <div className="bg-white dark:bg-gray-700/50 rounded-lg p-3 mt-2 border border-purple-100 dark:border-purple-900/50">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            <strong className="text-purple-600 dark:text-purple-400">Важно:</strong> Дополнительные услуги могут значительно повысить эффективность внедрения ИИ. 
            Правильно подготовленные данные позволяют ИИ-системам работать точнее, а квалифицированное консультирование 
            помогает избежать типичных ошибок и оптимизировать образовательные процессы.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;